import { Field, TextOutput, Link } from 'Components/Core';
import { FieldSet, ListFieldSection } from 'Components/Layout';
import { IListRowParams } from '../types';

const AgsExportConfigurationListRowAdmin: React.FC<IListRowParams> = ({
  configuration,
  agsExportConfigurationDeleteDialog,
}) => {
  return (
    <ListFieldSection>
      <Field input={<TextOutput />} value={configuration.Name} />
      <FieldSet visible={configuration.IsStandardConfiguration}>
        <Field
          input={<Link />}
          to={'/admin/ags-export-configuration/' + configuration.Id}
          content="View Configuration"
        />
      </FieldSet>
      <ListFieldSection visible={!configuration.IsStandardConfiguration}>
        <Field
          input={<Link />}
          to={'/admin/ags-export-configuration/' + configuration.Id}
          content="Edit Configuration"
        />
        <Field
          input={<Link />}
          to={'#'}
          content="Delete Configuration"
          onClick={() => {
            agsExportConfigurationDeleteDialog(configuration.Id);
          }}
        />
      </ListFieldSection>
    </ListFieldSection>
  );
};

export { AgsExportConfigurationListRowAdmin };
